<template>
  <div>
    <b-tabs>
      <!-- <b-tab class="tab-margin" title="通常配送">
        <div v-if="isAgent() || isAdmin()">
          <shipping-fee :editable="true"/>
        </div>
        <div v-if="isSeller()">
          <shipping-fee :editable="false"/>
        </div>
      </b-tab>
      <b-tab class="tab-margin" title="超速便配送">
        <div v-if="isAgent() || isAdmin()">
          <shipping-fee-dhl :editable="true"/>
        </div>
        <div v-if="isSeller()">
          <shipping-fee-dhl :editable="false"/>
        </div>
      </b-tab> -->
      <b-tab class="tab-margin" title="A">
        <div v-if="isAgent() || isAdmin()">
          <shipping-fee-type :editable="true" :feeType="feeTypeA" :version="versionA"/>
        </div>
        <div v-if="isSeller()">
          <shipping-fee-type :editable="false" :feeType="feeTypeA" :version="versionA"/>
        </div>
      </b-tab>
      <b-tab  v-on:click="doActiveB" class="tab-margin" title="B">
        <div v-if="isAgent() || isAdmin()">
          <shipping-fee-type :editable="true" :feeType="feeTypeB" :version="versionB"/>
        </div>
        <div v-if="isSeller()">
          <shipping-fee-type :editable="false" :feeType="feeTypeB" :version="versionB"/>
        </div>
      </b-tab>
      <b-tab  v-on:click="doActiveC" class="tab-margin" title="C">
        <div v-if="isAgent() || isAdmin()">
          <shipping-fee-type :editable="true" :feeType="feeTypeC" :version="versionC"/>
        </div>
        <div v-if="isSeller()">
          <shipping-fee-type :editable="false" :feeType="feeTypeC" :version="versionC"/>
        </div>
      </b-tab>
      <b-tab  v-on:click="doActiveD" class="tab-margin" title="D">
        <div v-if="isAgent() || isAdmin()">
          <shipping-fee-type :editable="true" :feeType="feeTypeD" :version="versionD"/>
        </div>
        <div v-if="isSeller()">
          <shipping-fee-type :editable="false" :feeType="feeTypeD" :version="versionD"/>
        </div>
      </b-tab>
      <b-tab  v-on:click="doActiveE" class="tab-margin" title="E">
        <div v-if="isAgent() || isAdmin()">
          <shipping-fee-type :editable="true" :feeType="feeTypeE" :version="versionE"/>
        </div>
        <div v-if="isSeller()">
          <shipping-fee-type :editable="false" :feeType="feeTypeE" :version="versionE"/>
        </div>
      </b-tab>
      <b-tab  v-on:click="doActiveF" class="tab-margin" title="F">
        <div v-if="isAgent() || isAdmin()">
          <shipping-fee-type :editable="true" :feeType="feeTypeF" :version="versionF"/>
        </div>
        <div v-if="isSeller()">
          <shipping-fee-type :editable="false" :feeType="feeTypeF" :version="versionF"/>
        </div>
      </b-tab>
      <b-tab  v-on:click="doActiveG" class="tab-margin" title="G">
        <div v-if="isAgent() || isAdmin()">
          <shipping-fee-type :editable="true" :feeType="feeTypeG" :version="versionG"/>
        </div>
        <div v-if="isSeller()">
          <shipping-fee-type :editable="false" :feeType="feeTypeG" :version="versionG"/>
        </div>
      </b-tab>
      <b-tab  v-on:click="doActiveH" class="tab-margin" title="H">
        <div v-if="isAgent() || isAdmin()">
          <shipping-fee-type :editable="true" :feeType="feeTypeH" :version="versionH"/>
        </div>
        <div v-if="isSeller()">
          <shipping-fee-type :editable="false" :feeType="feeTypeH" :version="versionH"/>
        </div>
      </b-tab>
      <b-tab  v-on:click="doActiveI" class="tab-margin" title="I">
        <div v-if="isAgent() || isAdmin()">
          <shipping-fee-type :editable="true" :feeType="feeTypeI" :version="versionI"/>
        </div>
        <div v-if="isSeller()">
          <shipping-fee-type :editable="false" :feeType="feeTypeI" :version="versionI"/>
        </div>
      </b-tab>
      <b-tab  v-on:click="doActiveJ" class="tab-margin" title="J">
        <div v-if="isAgent() || isAdmin()">
          <shipping-fee-type :editable="true" :feeType="feeTypeJ" :version="versionJ"/>
        </div>
        <div v-if="isSeller()">
          <shipping-fee-type :editable="false" :feeType="feeTypeJ" :version="versionJ"/>
        </div>
      </b-tab>
      <!-- <b-tab class="tab-margin" title="C">
        <div v-if="isAgent() || isAdmin()">
          <shipping-fee-type :editable="true" :feeType="feeTypeC"/>
        </div>
        <div v-if="isSeller()">
          <shipping-fee-type :editable="false" :feeType="feeTypeC"/>
        </div>
      </b-tab> -->
    </b-tabs>
  </div>
</template>

<script>
import Vue from 'vue';
import BaseView from '@/views/BaseView';
// import ShippingFee from '@/components/shipping-fee/ShippingFee';
// import ShippingFeeDHL from '@/components/shipping-fee/ShippingFeeDHL';
import ShippingFeeType from '@/components/shipping-fee/ShippingFeeType';

export default {
  mixins: [BaseView],
  data() {
    return {
      feeTypeA: 'A',
      feeTypeB: 'B',
      feeTypeC: 'C',
      feeTypeD: 'D',
      feeTypeE: 'E',
      feeTypeF: 'F',
      feeTypeG: 'G',
      feeTypeH: 'H',
      feeTypeI: 'I',
      feeTypeJ: 'J',
      versionA: 1,
      versionB: 0,
      versionC: 0,
      versionD: 0,
      versionE: 0,
      versionF: 0,
      versionG: 0,
      versionH: 0,
      versionI: 0,
      versionJ: 0,
    }
  },
  created() { this.updateTitle(this.$i18n.t('shippingFee.title')); },
  methods: {
    selectedSeller($event) {
      this.memberId = $event.amazonAccount;
    },
    doActiveA(){
      if(this.versionA === 0){
        this.versionA = this.versionA + 1;
      }
    },
    doActiveB(){
      if(this.versionB === 0){
        this.versionB = this.versionB + 1;
      }
    },
    doActiveC(){
      if(this.versionC === 0){
        this.versionC = this.versionC + 1;
      }
    },
    doActiveD(){
      if(this.versionD === 0){
        this.versionD = this.versionD + 1;
      }
    },
    doActiveE(){
      if(this.versionE === 0){
        this.versionE = this.versionE + 1;
      }
    },
    doActiveF(){
      if(this.versionF === 0){
        this.versionF = this.versionF + 1;
      }
    },
    doActiveG(){
      if(this.versionG === 0){
        this.versionG = this.versionG + 1;
      }
    },
    doActiveH(){
      if(this.versionH === 0){
        this.versionH = this.versionH + 1;
      }
    },
    doActiveI(){
      if(this.versionI === 0){
        this.versionI = this.versionI + 1;
      }
    },
    doActiveJ(){
      if(this.versionJ === 0){
        this.versionJ = this.versionJ + 1;
      }
    },
  },
};

// Vue.component('shipping-fee', ShippingFee);
// Vue.component('shipping-fee-dhl', ShippingFeeDHL);
Vue.component('shipping-fee-type', ShippingFeeType);
</script>

<style>
.tab-margin {
  margin-top: 1rem;
}
</style>
